export default __webpack_public_path__ + "cf54bc78b5c2fe27c3d5978c66fdb30e.png";